import React, { useState, useMemo } from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

export default function DebugEventFeed({ events }) {
  const [kindFilter, setKindFilter] = useState("all");
  const safeEvents = events || [];

  const kinds = useMemo(() => {
    const set = new Set(safeEvents.map((e) => e.kind));
    return ["all", ...Array.from(set)];
  }, [safeEvents]);

  const filtered = kindFilter === "all" ? safeEvents : safeEvents.filter((e) => e.kind === kindFilter);

  return (
    <Paper style={{ padding: 12, height: 700, overflow: "auto", minWidth: 360 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">Event feed</Typography>
        <Select value={kindFilter} onChange={(e) => setKindFilter(e.target.value)}>
          {kinds.map((k) => <MenuItem key={k} value={k}>{k}</MenuItem>)}
        </Select>
      </div>
      <List dense>
        {filtered.map((e) => (
          <ListItem key={`${e.observedAtUtc}-${e.serverTick}-${e.steamId}-${e.kind}`} divider>
            <ListItemText
              primary={`${e.source}/${e.kind} — ${e.name}`}
              secondary={`${e.summary} · round ${e.roundNumber} · tick ${e.serverTick}`}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
